import { render, staticRenderFns } from "./OnUpload.vue?vue&type=template&id=259e2720&scoped=true&"
import script from "./OnUpload.vue?vue&type=script&lang=ts&"
export * from "./OnUpload.vue?vue&type=script&lang=ts&"
import style0 from "./OnUpload.vue?vue&type=style&index=0&id=259e2720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259e2720",
  null
  
)

export default component.exports